import classNames from "classnames";
import { Typography } from "components/atoms/Typography";
import "./index.scss";

interface IProps {
  complete: number;
  total: number;
  filled?: number;
  label: string;
  labelSecondary?: string;
  progressColor: string;
  styles?: string;
  isShowLable?: boolean;
  isShowProgressCount?: boolean;
  isMobile?: boolean;
  topic: string;
  percentage?: number;
  isShowPercentageOnTop?: boolean;
}

export const HorizontalProgressBar = ({
  complete,
  total,
  filled,
  label,
  labelSecondary,
  progressColor,
  styles,
  isShowLable = true,
  isShowProgressCount = true,
  isMobile,
  topic,
  percentage,
  isShowPercentageOnTop = true,
}: IProps) => {
  const barWidth = percentage
    ? percentage
    : filled
      ? Math.round((filled * 100) / total)
      : Math.round((complete * 100) / total);

  return (
    <div className="horizontal-progress-bar-container">
      {isMobile ? null : isShowPercentageOnTop ? (
        <div className="progress-bar-detail-container">
          <div className="progress-name">
            {isShowLable ? (
              <>
                <Typography label={label} variant="h9Bold" />
                {labelSecondary ? (
                  <Typography label={labelSecondary} variant="h10Book" />
                ) : null}
              </>
            ) : null}
          </div>

          <div className="progress-count">
            {isShowProgressCount ? (
              <Typography label={`${complete} / ${total}`} variant="h9Bold" />
            ) : null}
          </div>
        </div>
      ) : null}
      {isMobile ? <Typography label={topic} variant="h8Med" /> : null}
      <div
        className={classNames("outer-horizontal-progress-bar", {
          [`${styles}`]: styles,
        })}
      >
        <div
          style={{ width: `${barWidth}%` }}
          className={classNames(
            "inner-horizontal-progress-bar",
            `inner-horizontal-progress-bar-${progressColor}`
          )}
        ></div>
      </div>
      {isMobile ? <Typography label={label} variant="h9Medium" /> : null}
      {isMobile ? null : !isShowPercentageOnTop ? (
        <div className="progress-bar-detail-container">
          <div className="progress-name">
            {isShowLable ? (
              <>
                <Typography label={label} variant="h9Bold" />
                {labelSecondary ? (
                  <Typography label={labelSecondary} variant="h10Book" />
                ) : null}
              </>
            ) : null}
          </div>

          <div className="progress-count">
            {isShowProgressCount ? (
              <Typography label={`${complete} / ${total}`} variant="h9Bold" />
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};
